<div class="container mt-3 mx-auto">
  <div class="alert alert-info" *ngIf="!validacoesScr || !validacoesScr.length">
    Não foram encontradas validações SCR com os filtros informados.
  </div>

  <div *ngIf="validacoesScr && validacoesScr.length">

    <bn-paginacao [total]="atributosPaginacao.count"
      [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
      [opcoesTamanhoPagina]="opcoesPaginacao">

      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th id="col-id-sh" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'id'"
                  [nomeAtributoExibicao]="'Id. Validação'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-data-validacao" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataValidacao'"
                  [nomeAtributoExibicao]="'Data da validação'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-tipo-validacao" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'tipoValidacao'"
                  [nomeAtributoExibicao]="'Tipo da validação'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-qtd-sucesso" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'tipoValidacao'"
                  [nomeAtributoExibicao]="'Qtde. SHs sucesso'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-qtd-erro" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'tipoValidacao'"
                  [nomeAtributoExibicao]="'Qtde. SHs erro'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th scope="col"></th> <!--lupa para visualizar os detalhes-->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let validacaoScr of validacoesScr" id="pointer" [routerLink]="['/validacoes-scr', validacaoScr.id]">
              <td>{{ validacaoScr.id }}</td>
              <td>{{ validacaoScr.dataValidacao | date: 'dd/MM/yyyy HH:mm'}}</td>
              <td>{{ labelTipoValidacaoScr(validacaoScr.tipoValidacao) }}</td>
              <td>{{ validacaoScr.qtdeSolicitacoesHonraValidadasComSucesso }}</td>
              <td>{{ validacaoScr.qtdeSolicitacoesHonraValidadasComErro }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </bn-paginacao>
  </div>
</div>